if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();

        this.modalContent =
          this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        if (cartNotification) {
          cartNotification.setActiveElement(
            this.openedBy
          );
        }

        this.modalContent.replaceChildren();

        if (preventFocus) {
          this.openedBy = null;
        }

        super.hide();
      }

      show(opener) {
        const scrollPosition = window.pageYOffset;

        opener.setAttribute(
          'aria-disabled',
          true
        );

        opener.classList.add('loading');

        const dtLoader =
          document.createElement('div');

        dtLoader.className = 'dT_loading';

        const loader =
          document.createElement('div');

        loader.className = 'loading';

        dtLoader.appendChild(loader);

        setTimeout(() => {
          $('.quick-add-modal[open]')
            .find('.main-product_info')
            .addClass(
              'quick-add-modal-in-progress'
            );
        }, 2000);

        setTimeout(() => {
          $('.main-product_info')
            .removeClass(
              'quick-add-modal-in-progress'
            );
        }, 4000);

        opener
          .querySelector(
            '.loading-overlay__spinner'
          )
          .classList.remove('hidden');

        fetch(
          opener.getAttribute(
            'data-product-url'
          )
        )
          .then((response) =>
            response.text()
          )
          .then((responseText) => {
            const responseHTML =
              new DOMParser().parseFromString(
                responseText,
                'text/html'
              );

            this.productElement =
              responseHTML.querySelector(
                'section[id^="MainProduct-"]'
              );

            this.preventDuplicatedIDs();

            this.removeDOMElements();

            this.setInnerContent(
              this.modalContent,
              this.productElement
            );

            if (
              window.Shopify &&
              Shopify.PaymentButton
            ) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) {
              window.ProductModel.loadShopifyXR();
            }

            this.removeGalleryListSemantic();

            this.preventVariantURLSwitching();

            DTWishlist();

            super.show(opener);

            window.scrollTo({
              top: scrollPosition,
              behavior: 'instant',
            });
          })
          .finally(() => {
            opener.removeAttribute(
              'aria-disabled'
            );

            opener.classList.remove(
              'loading'
            );

            opener
              .querySelector(
                '.loading-overlay__spinner'
              )
              .classList.add('hidden');
          });
      }

      setInnerContent(element, sourceElement) {
        element.replaceChildren(
          ...sourceElement.cloneNode(true)
            .childNodes
        );

        element
          .querySelectorAll('script')
          .forEach((oldScriptTag) => {
            const newScriptTag =
              document.createElement(
                'script'
              );

            Array.from(
              oldScriptTag.attributes
            ).forEach((attribute) => {
              newScriptTag.setAttribute(
                attribute.name,
                attribute.value
              );
            });

            newScriptTag.textContent =
              oldScriptTag.textContent;

            oldScriptTag.parentNode.replaceChild(
              newScriptTag,
              oldScriptTag
            );
          });
      }

      preventVariantURLSwitching() {
        const variantPicker =
          this.modalContent.querySelector(
            'variant-radios,variant-selects'
          );

        if (!variantPicker) return;

        variantPicker.setAttribute(
          'data-update-url',
          'false'
        );

        $('input:radio[name="Color"]').click(
          function () {
            $('input:radio[name="Color"]')
              .next('.swatch-element')
              .removeClass('clicked');

            $(this)
              .next('.swatch-element')
              .addClass('clicked');
          }
        );
      }

      removeDOMElements() {
        const pickupAvailability =
          this.productElement.querySelector(
            'pickup-availability'
          );

        if (pickupAvailability) {
          pickupAvailability.remove();
        }

        const productModal =
          this.productElement.querySelector(
            'product-modal'
          );

        if (productModal) {
          productModal.remove();
        }

        const productEnquiry =
          this.productElement.querySelector(
            'enquiryPopUp'
          );

        if (productEnquiry) {
          productEnquiry.remove();
        }

        const modalDialog =
          this.productElement.querySelectorAll(
            'modal-dialog'
          );

        if (modalDialog) {
          modalDialog.forEach((modal) =>
            modal.remove()
          );
        }
      }

      preventDuplicatedIDs() {
        const sectionId =
          this.productElement.dataset.section;

        this.productElement
          .querySelectorAll('*')
          .forEach((element) => {
            if ( element.id && typeof element.id === 'string' ) {
        element.id = element.id.replace(
          new RegExp(sectionId, 'g'),
          `${sectionId}`
        );
      }

            Array.from(
              element.attributes
            ).forEach((attribute) => {
              if (
                typeof attribute.value ===
                'string'
              ) {
                attribute.value =
                  attribute.value.replace(
                  new RegExp(sectionId, 'g'),
                  `quickadd-${sectionId}`
                )
              }
            });
          });

        this.productElement
          .querySelectorAll(
            'variant-selects, variant-radios'
          )
          .forEach((variantSelect) => {
            variantSelect.dataset.originalSection =
              sectionId;
          });
      }

      removeGalleryListSemantic() {
        const galleryList =
          this.modalContent.querySelector(
            '[id^="Slider-Gallery"]'
          );

        if (!galleryList) return;

        galleryList.setAttribute(
          'role',
          'presentation'
        );

        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) =>
            li.setAttribute(
              'role',
              'presentation'
            )
          );

        const FBT =
          this.modalContent.querySelector(
            '[id^="dT_bundleSelector"]'
          );

        if (FBT) FBT.remove();

        const Tabs =
          this.modalContent.querySelector(
            '[class^="product__info-as-bottom-tabs"]'
          );

        if (Tabs) Tabs.remove();
      }
    }
  );
}